/* unplugin-vue-components disabled */import { render } from "./file-icon.vue?vue&type=template&id=9c937dac&scoped=true"
import script from "./file-icon.vue?vue&type=script&setup=true&lang=js"
export * from "./file-icon.vue?vue&type=script&setup=true&lang=js"

import "./file-icon.vue?vue&type=style&index=0&id=9c937dac&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c937dac"],['__file',"src/controls/file-icon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9c937dac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9c937dac', __exports__)) {
    api.reload('9c937dac', __exports__)
  }
  
  module.hot.accept("./file-icon.vue?vue&type=template&id=9c937dac&scoped=true", () => {
    api.rerender('9c937dac', render)
  })

}


export default __exports__